import { render, staticRenderFns } from "./OffersViewInfoCards.vue?vue&type=template&id=58eb0dc3&scoped=true"
import script from "./OffersViewInfoCards.vue?vue&type=script&lang=js"
export * from "./OffersViewInfoCards.vue?vue&type=script&lang=js"
import style0 from "./OffersViewInfoCards.vue?vue&type=style&index=0&id=58eb0dc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58eb0dc3",
  null
  
)

export default component.exports